import { render, staticRenderFns } from "./dataPerfect.vue?vue&type=template&id=38a07553&scoped=true"
import script from "./dataPerfect.vue?vue&type=script&lang=js"
export * from "./dataPerfect.vue?vue&type=script&lang=js"
import style0 from "./dataPerfect.vue?vue&type=style&index=0&id=38a07553&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a07553",
  null
  
)

export default component.exports